// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * WL.Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
/**
 *
 * @export
 * @interface ClassroomRepresentation
 */
export interface ClassroomRepresentation {
  /**
   *
   * @type {string}
   * @memberof ClassroomRepresentation
   */
  schoolId: string
  /**
   *
   * @type {string}
   * @memberof ClassroomRepresentation
   */
  classId: string
  /**
   *
   * @type {string}
   * @memberof ClassroomRepresentation
   */
  classCode: string
  /**
   *
   * @type {string}
   * @memberof ClassroomRepresentation
   */
  className: string
  /**
   *
   * @type {number}
   * @memberof ClassroomRepresentation
   */
  blakeClassroomId: number
}

/**
 * Check if a given object implements the ClassroomRepresentation interface.
 */
export function instanceOfClassroomRepresentation(value: object): boolean {
  let isInstance = true
  isInstance = isInstance && 'schoolId' in value
  isInstance = isInstance && 'classId' in value
  isInstance = isInstance && 'classCode' in value
  isInstance = isInstance && 'className' in value
  isInstance = isInstance && 'blakeClassroomId' in value

  return isInstance
}

export function ClassroomRepresentationFromJSON(
  json: any,
): ClassroomRepresentation {
  return ClassroomRepresentationFromJSONTyped(json, false)
}

export function ClassroomRepresentationFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ClassroomRepresentation {
  if (json === undefined || json === null) {
    return json
  }
  return {
    schoolId: json['school_id'],
    classId: json['class_id'],
    classCode: json['class_code'],
    className: json['class_name'],
    blakeClassroomId: json['blake_classroom_id'],
  }
}

export function ClassroomRepresentationToJSON(
  value?: ClassroomRepresentation | null,
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    school_id: value.schoolId,
    class_id: value.classId,
    class_code: value.classCode,
    class_name: value.className,
    blake_classroom_id: value.blakeClassroomId,
  }
}
